<template>
  <div class="freeTry">
      <el-dialog title="“Tip Biu BI”免费试用申请" :visible="visible" @update:visible="v => $emit('update:visible',v)" @close='cancel'>
        <div class="el-dialog-body">
            <div class="formSub" v-show="showForm">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
                    <el-form-item label="公司" prop="companyName">
                        <el-input v-model="ruleForm.companyName" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item
                    prop="email"
                    label="邮箱"
                    :rules="[
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                    ]">
                        <el-input v-model="ruleForm.email" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="手机" prop="phone">
                        <el-input v-model="ruleForm.phone" auto-complete="off"/>
                    </el-form-item>
                </el-form>
                <p class="freeTryHint">请留下您的信息，我们的服务人员将会尽快与您联系，为您介绍产品的功能亮点！</p>
            </div>
            <div class="successTry" v-show="!showForm">
                <img src="../../assets/img/success.png" />
                <ul>
                    <li>您已成功提交“Tip Biu BI”的免费试用申请！</li>
                    <li>我们将通过邮箱发送给您Tip Biu BI的帐号及密码。</li>
                </ul>
                <div class="countDown">
                    <span>{{count}}s</span>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="cancel" v-if="!showForm">关闭</el-button>
            <el-button type="primary"  @click="submitForm('ruleForm')" v-loading="loading" v-if="showForm">注册</el-button>
            <!-- <a class="freeLogin" v-if="showForm">已有帳號？<a href="https://margin-demo.apps.digiwincloud.com/index.html#/account/login" target="_blank">立即登入</a></p> -->
        </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: 'ISVFreeTry',
    props: {
      item: {},
      visible: false
    },
    watch: {
      visible(){
        if (this.visible) {
            this.showForm = true;
            this.resetForm('ruleForm'); 
        }
      }
    },
    data(){
      var checkPhone = (rule, value, callback) => {//手機號校驗
        if(!value) {
            return callback(new Error('请输入手机号'));
        }
        if (value!='') {
          const reg = /^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/
          //console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }else{
            callback();
        }
      };
      return {
        showForm: true,
        ruleForm: {
          companyName: '',
          phone: '',
          email: ''
        },
        rules: {
          companyName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          phone: [
            { required: true, validator: checkPhone, trigger: 'blur'}
          ]
        },
        count:'',
        timer: null,
        loading: false
      }
    },
    mounted() {
    },
    created(){
        
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log('submit!');
                    this.loading = true;
                    // 发送邮件
                    var that = this;
                    this.$http.post('/topbicn/isv/api/email',
                    Object.assign(that.ruleForm, {extend2: 'CN'}),
                    {headers: { "Content-Type": "application/json" }})
                    .then(function (response) {
                        that.loading = false;
                        if(response.data=='ok'){
                           that.saveToDatabase();
                        }else {
                            that.$message.info(response.data);
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
      },
      resetForm(formName) {//重置
        if (this.$refs[formName]!==undefined) {
            this.$nextTick(()=>{
                this.$refs[formName].resetFields();
            })   
        }
      },
      cancel() { // 取消
        this.$emit('update:visible',false);
        clearInterval(this.timer);
        this.timer = null;
      },
      setTime(num){//倒计时
        const TIME_COUNT = num;
        this.count = TIME_COUNT;
        if (!this.timer) {
            //this.count = TIME_COUNT;
            this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.$emit('update:visible',false);//彈框關閉
                }
            }, 1000)
        }
      },
      saveToDatabase() {//存入数据库
        var that = this;
        this.$http.post('/backend/web/companyInfo',
        Object.assign(that.ruleForm, {extend2: 'CN'}),
        {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status==200){
                that.showForm = false;
                that.setTime(10);
            }
        })
        .catch(function (error) {
            console.log(error)
        });
      }

    }
  }
</script>
<style>
.freeTry .el-dialog{
    width: 628px;
    height: 390px;
    background: url(../../assets/img/tank.png) no-repeat center center;
    box-shadow: 0 1px 3px rgba(0,0,0,0);
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,0);
}
.freeTry .el-dialog__body{
    padding: 0 30px 20px;
}
.freeTry .el-dialog__header{
    text-align: center;
    padding: 60px 70px 10px 20px;
}
.freeTry .el-dialog__headerbtn{
    right: 35px;
}
.freeTry .el-dialog__title{
    font-size: 24px;
    color: #00AAFF;
}
.formSub{
    margin-top: 20px;
}
.freeTry .el-form{
    overflow: hidden;
}
.freeTry .el-form-item{
    float: left;
    width: 45%;
}
.freeTry .el-form-item__label{
    letter-spacing: 4px;
    line-height: 20px;
    padding: 0 10px 0 0;
}
.freeTry .el-form-item__content{
    line-height: normal;
}
.freeTry .el-select{
    width: 100%;
}
.freeTry .el-input__suffix{
    right: 0;
}
.freeTry .el-input{
    /* width: 150px; */
    width: 100%;
    font-size:12px;
}
.freeTry .el-input__inner{
    border: 0;
    border-bottom: #000 1px solid;
    border-radius: 0px;
    color: #000;
    padding:0; 
    height: 20px;
    line-height: 20px;
}
.freeTry .el-input--suffix .el-input__inner{
    padding-right: 0;
}
.freeTry .el-select .el-input .el-select__caret{
    color: #000;
}
.freeTryHint{
    color: red;
    font-size: 12px;
    padding: 0 0 0 20px;
    text-indent: 25px;
}
.freeTry .el-dialog__footer{
    text-align: center;
    padding: 0 80px 20px 20px;
}
.freeTry .el-input__icon{
    line-height: 20px;
}
.freeTry .el-button{
    width: 150px;
    height: 32px;
    line-height: 32px;
    padding: 0; 
    border-radius: 50px;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    border: 0;
    background: #00d4ff; /* Old browsers */
    background: -moz-linear-gradient(top,  #00d4ff 1%, #00c4ff 50%, #00abff 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top,  #00d4ff 1%,#00c4ff 50%,#00abff 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom,  #00d4ff 1%,#00c4ff 50%,#00abff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00d4ff', endColorstr='#00abff',GradientType=0 ); /* IE6-9 */

}
.successTry{
    text-align: center;
    margin-right: 60px;
}
.successTry ul li{
    margin-top:5px;
}
.countDown{
    text-align:center;
    margin-top: 10px;
}
.countDown span{
    display:inline-block;
    width: 32px;
    height: 32px;
    line-height: 32px;
    border: #8D979B 1px solid;
    color: #000;
    border-radius: 100%;
    -moz-border-radius: 100%;
    -webkit-border-radius: 100%;
}
.freeLogin{
    display: inline-block;
    margin-left: 10px;
}
.freeLogin a{
    color: #00AAFF!important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ISVFreeTry.vue